export class ValidationContextDefs {
  public static readonly ID_COMPLETE_PROJECT: string = 'completeProject';
  public static readonly ID_WAGO_SPEEDWAY_CALCULATIONS: string = 'wagoAutomationCalc';
}
